function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.3333 21.2089C22.4044 21.2089 21.5733 21.5756 20.9378 22.15L12.2233 17.0778C12.2844 16.7967 12.3333 16.5156 12.3333 16.2222C12.3333 15.9289 12.2844 15.6478 12.2233 15.3667L20.84 10.3433C21.5 10.9544 22.3678 11.3333 23.3333 11.3333C25.3622 11.3333 27 9.69556 27 7.66667C27 5.63778 25.3622 4 23.3333 4C21.3044 4 19.6667 5.63778 19.6667 7.66667C19.6667 7.96 19.7156 8.24111 19.7767 8.52222L11.16 13.5456C10.5 12.9344 9.63222 12.5556 8.66667 12.5556C6.63778 12.5556 5 14.1933 5 16.2222C5 18.2511 6.63778 19.8889 8.66667 19.8889C9.63222 19.8889 10.5 19.51 11.16 18.8989L19.8622 23.9833C19.8011 24.24 19.7644 24.5089 19.7644 24.7778C19.7644 26.7456 21.3656 28.3467 23.3333 28.3467C25.3011 28.3467 26.9022 26.7456 26.9022 24.7778C26.9022 22.81 25.3011 21.2089 23.3333 21.2089Z"
});

function SvgIcLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLink);
export default ForwardRef;